import React from "react";
import { View } from "react-native";

import { uniqueId } from "lodash";
import Svg, { Path, Defs, LinearGradient, Stop, G } from "react-native-svg";
import { isWeb } from "../../../../../helpers/utils";

export default function ScaleIcon(props) {
  const filterId = "filter0_new_element_" + uniqueId();
  const filterUrl = "url(#" + filterId + ")";

  const width = props.width || 50;
  const height = props.height || 50;

  return (
    <View style={props.style}>
      <Svg
        width={width}
        height={height}
        viewBox="0 0 50 50"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <G filter={filterUrl}>
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M25 41C36.0457 41 45 32.0457 45 21C45 9.9543 36.0457 1 25 1C13.9543 1 5 9.9543 5 21C5 32.0457 13.9543 41 25 41Z"
            fill="white"
            stroke="url(#paint0_linear_12371_138862)"
            strokeWidth="2"
          />
          <Path
            d="M32.3125 30.75H17.6875V32.375H32.3125V30.75Z"
            fill="url(#paint1_linear_12371_138862)"
          />
          <Path
            d="M37.8635 19.7366L32.9885 12.4241C32.8374 12.1982 32.5839 12.0625 32.3125 12.0625H25.8125V10.4375C25.8125 9.98819 25.4485 9.625 25 9.625C24.5515 9.625 24.1875 9.98819 24.1875 10.4375V12.0625H17.6875C17.4161 12.0625 17.1626 12.1982 17.0115 12.4241L12.1365 19.7366C12.0479 19.8698 12 20.0274 12 20.1875C12 22.5324 14.1743 25.0625 17.6875 25.0625C21.2007 25.0625 23.375 22.5324 23.375 20.1875C23.375 20.0274 23.3271 19.8698 23.2385 19.7366L19.2061 13.6875H24.1875V29.125H25.8125V13.6875H30.7939L26.7615 19.7366C26.6729 19.8698 26.625 20.0274 26.625 20.1875C26.625 22.5324 28.7993 25.0625 32.3125 25.0625C35.8257 25.0625 38 22.5324 38 20.1875C38 20.0274 37.9521 19.8698 37.8635 19.7366ZM21.0439 19.375H14.3311L17.6875 14.3399L21.0439 19.375ZM28.9561 19.375L32.3125 14.3399L35.6689 19.375H28.9561Z"
            fill="url(#paint2_linear_12371_138862)"
          />
        </G>
        <Defs>
          {isWeb ? (
            <filter
              id={filterId}
              x="0"
              y="0"
              width="50"
              height="50"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="4" />
              <feGaussianBlur stdDeviation="2" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_12371_138862"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_12371_138862"
                result="shape"
              />
            </filter>
          ) : null}
          <LinearGradient
            id="paint0_linear_12371_138862"
            x1="5"
            y1="9.6747"
            x2="24.255"
            y2="49.0185"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#05858A" />
            <Stop offset="1" stopColor="#2AE8CB" />
          </LinearGradient>
          <LinearGradient
            id="paint1_linear_12371_138862"
            x1="17.6875"
            y1="31.1024"
            x2="17.7949"
            y2="33.0777"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#05858A" />
            <Stop offset="1" stopColor="#2AE8CB" />
          </LinearGradient>
          <LinearGradient
            id="paint2_linear_12371_138862"
            x1="12"
            y1="13.8539"
            x2="19.6902"
            y2="34.8052"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#05858A" />
            <Stop offset="1" stopColor="#2AE8CB" />
          </LinearGradient>
        </Defs>
      </Svg>
    </View>
  );
}
